export const IDS = {
  nav: {
    home: "nav-home-link",
    privacy: "nav-privacy-link",
    support: "nav-support-link",
    accessibility: "nav-accessibility-link",
    logo: "nav-logo",
  },
  home: {
    hero: "home-hero",
    heroCta: "home-hero-appstore-cta",
    heroPhone: "home-hero-phone",
    marquee: "home-marquee",
    statCards: "home-stat-cards",
    manifesto: "home-manifesto",
    features: "home-features",
    neverDo: "home-never-do",
    keychain: "home-keychain",
  },
  privacy: { page: "privacy-page" },
  support: { page: "support-page", email: "support-email-link", faq: "support-faq" },
  accessibility: { page: "accessibility-page" },
  footer: {
    root: "site-footer",
    privacy: "footer-privacy-link",
    support: "footer-support-link",
    accessibility: "footer-accessibility-link",
  },
};
